import { useEffect, useState } from 'react';

import { getInjector } from '@/services/angularjs-bridge';

const useCustomItemEditorSettings = () => {
    // eslint-disable-next-line
    const [customItemEditorSettings, setCustomItemEditorSettings] = useState<any>();
    useEffect(() => {
        const angularJSInjector = getInjector();

        if (angularJSInjector.has && angularJSInjector.has('CustomItemEditorSettings')) {
            const settings = angularJSInjector.get('CustomItemEditorSettings');
            setCustomItemEditorSettings(settings);
        }

    }, []);
    return { customItemEditorSettings };
};

export default useCustomItemEditorSettings;
